module.exports = __webpack_public_path__ + "static/img/zhinenghuachejian.5f77645b.png";